<template>
  <div class="contentBox pt-50">
    <div class="breadCrumbs">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Members</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="yiweiBox">
      <div class="yiweiLeft yiweiLeftpeople" id="yiweiLeft">
        <ul class="yiweiUl">
          <li class="yiweili">
            <div class="main">
              <div v-html="yiWeiData.info"></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="yiweiRight">
        <div class="userInfo fixedBox" id="userInfo">
          <div class="userimgbox">
            <img :src="yiWeiData.head" class="userimg">
          </div>
          <p class="p1 mt-20">{{yiWeiData.name}}</p>
          <p class="p2 mt-20">{{yiWeiData.description}}</p>
          <p class="p2 mt-15">Tel: {{yiWeiData.telephone}}</p>
          <p class="p2 mt-15">Email: {{yiWeiData.email}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/yiwei.less";
import apiSign from "../assets/js/apiSign";
// import { mapState } from "vuex";

export default {
  data() {
    return {
      yiWeiData: {},
      id: "",
      xiaodiId: ""
    };
  },
  mounted: function() {
    this.getYiWeiDataFn();
    this.rightFixedFn();
    this.xiaodiId = sessionStorage.getItem("yiweiId");
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.rightFixedFn);
  },
  methods: {
    getYiWeiDataFn() {
      let field = { rtime: apiSign.getTime() };
      let getUrl = "/yiwei/app/yiwei";
      let xiaodiId = this.$route.params.id;
      let sessionXiaoDiId = sessionStorage.getItem("yiweiId");
      if (xiaodiId != undefined) {
        getUrl = "/yiwei/members/info";
        field = { rtime: apiSign.getTime(), id: xiaodiId };
      }
      if (sessionXiaoDiId != null) {
        getUrl = "/yiwei/members/info";
        field = { rtime: apiSign.getTime(), id: sessionXiaoDiId };
      }
      this.axios
        .get(this.axios.defaults.baseURL + getUrl, {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          this.yiWeiData = resp.data.data;
        });
    },
    rightFixedFn: () => {
      window.scroll = function() {
        //变量t是滚动条滚动时，距离顶部的距离
        let t = document.documentElement.scrollTop || document.body.scrollTop;
        let scrollup = document.getElementById("userInfo");
        if (t > 169) {
          scrollup.style.top = "0px";
        } else {
          scrollup.style.top = "236px";
        }
      };
    }
  }
};
</script>
